import cloneDeep from 'lodash/cloneDeep';

// Note: Accessing this directly insetad of via dist/.esm caused an error with Webpack5
import { getRelativePosition } from 'chart.js/dist/helpers.esm';

import {
  BAR_CHART_OPTIONS, DEFAULT_CHART_OPTIONS, HISTOGRAM_CHART_OPTIONS, POINT_CHART_OPTIONS, ASSAY_CHART_OPTIONS
} from '../ChartConfiguration';

export const getChartConfigByKey = (chartConfigKey) => {
  if (chartConfigKey === 'bar') {
    return cloneDeep(BAR_CHART_OPTIONS);
  }

  if (chartConfigKey === 'point') {
    return cloneDeep(POINT_CHART_OPTIONS);
  }

  if (chartConfigKey === 'histogram') {
    return cloneDeep(HISTOGRAM_CHART_OPTIONS);
  }

  
  if (chartConfigKey === 'assay') {
    return cloneDeep(ASSAY_CHART_OPTIONS);
  }

  return cloneDeep(DEFAULT_CHART_OPTIONS);
}

export const getOnPointClickOptions = onClick => ({
  onClick,
  events: ['click', 'mousemove', 'mouseout'],
  interaction: {
    axis: 'xy',
    mode: 'point',
  }
});

export const getXValueByChartPosition = (clickEvent, chart) => {
  const canvasPosition = getRelativePosition(clickEvent, chart);

  // Substitute the appropriate scale IDs
  return chart.scales.x.getValueForPixel(canvasPosition.x);
}

